var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.67 70.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.67,
    height: 70.67,
    fill: "#fff",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,18.23c0,2.08-.01,4.1,0,6.13.01,1.7,1.14,3.13,2.78,3.53.35.09.73.11,1.09.11,1.92.01,3.84,0,5.76,0,.02,0,.05,0,.13.02,0,.12,0,.26,0,.39,0,6.72,0,13.44,0,20.15,0,2.3-1.56,3.86-3.85,3.86-6.39,0-12.77,0-19.16,0-2.29,0-3.86-1.57-3.86-3.86,0-8.83,0-17.66,0-26.49,0-2.29,1.57-3.85,3.86-3.85,4.27,0,8.55,0,12.82,0,.12,0,.25,0,.42,0ZM31.66,40.22c1.21,0,2.41,0,3.62,0,.76,0,1.27-.51,1.27-1.27,0-.84.02-1.68,0-2.52-.04-1.72-1.32-3.24-3.03-3.46-1.05-.13-2.13-.09-3.2-.07-1.72.03-3.24,1.31-3.46,3.02-.13.96-.07,1.95-.08,2.93,0,.88.49,1.37,1.37,1.37,1.17,0,2.34,0,3.51,0ZM35.33,28.01c0-2.02-1.64-3.67-3.66-3.67-2.02,0-3.66,1.63-3.67,3.66,0,2.01,1.64,3.67,3.66,3.67,2.03,0,3.67-1.64,3.67-3.66ZM35.29,46.33c.76,0,1.53,0,2.29,0,1.69,0,3.38,0,5.08,0,.64,0,1.15-.48,1.22-1.09.06-.61-.36-1.19-.97-1.32-.16-.03-.33-.03-.49-.03-4.63,0-9.26,0-13.89,0-.19,0-.38,0-.57,0-.52.04-.89.3-1.08.78-.33.82.28,1.66,1.21,1.66,2.4,0,4.81,0,7.21,0ZM41.45,34.11c.39,0,.79,0,1.18,0,.71-.01,1.25-.54,1.25-1.22,0-.68-.53-1.21-1.25-1.22-.8,0-1.6-.01-2.4,0-.71,0-1.24.55-1.23,1.23,0,.66.54,1.19,1.23,1.21.41,0,.81,0,1.22,0ZM41.44,40.22c.39,0,.79,0,1.18,0,.72-.01,1.25-.53,1.26-1.21,0-.68-.53-1.22-1.24-1.23-.8,0-1.6-.01-2.4,0-.71,0-1.24.55-1.24,1.23,0,.66.53,1.19,1.22,1.21.41.01.81,0,1.22,0Z",
    fill: "#000",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.53,19.01c2.16,2.15,4.31,4.31,6.53,6.53-.19.01-.3.03-.41.03-1.62,0-3.23,0-4.85,0-.88,0-1.37-.49-1.37-1.37,0-1.62,0-3.23,0-4.85,0-.1,0-.2,0-.3.03-.01.06-.03.09-.04Z",
    fill: "#000",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.66,40.22c-1.17,0-2.34,0-3.51,0-.88,0-1.37-.49-1.37-1.37,0-.98-.05-1.97.08-2.93.22-1.71,1.74-2.99,3.46-3.02,1.07-.02,2.14-.06,3.2.07,1.71.21,2.98,1.73,3.03,3.46.02.84.01,1.68,0,2.52,0,.76-.51,1.27-1.27,1.27-1.21,0-2.41,0-3.62,0Z",
    fill: "#a4ffad",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.33,28.01c0,2.02-1.64,3.66-3.67,3.66-2.01,0-3.67-1.66-3.66-3.67,0-2.02,1.65-3.65,3.67-3.66,2.01,0,3.66,1.65,3.66,3.67Z",
    fill: "#a4ffad",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.29,46.33c-2.4,0-4.81,0-7.21,0-.93,0-1.54-.84-1.21-1.66.19-.48.56-.74,1.08-.78.19-.01.38,0,.57,0,4.63,0,9.26,0,13.89,0,.16,0,.33,0,.49.03.61.12,1.03.71.97,1.32-.06.61-.57,1.09-1.22,1.09-1.69,0-3.38,0-5.08,0-.76,0-1.53,0-2.29,0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.45,34.11c-.41,0-.81,0-1.22,0-.69-.02-1.22-.54-1.23-1.21,0-.68.52-1.22,1.23-1.23.8-.01,1.6,0,2.4,0,.71,0,1.25.54,1.25,1.22,0,.68-.54,1.2-1.25,1.22-.39,0-.79,0-1.18,0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.44,40.22c-.41,0-.81,0-1.22,0-.69-.02-1.22-.55-1.22-1.21,0-.68.53-1.22,1.24-1.23.8-.01,1.6,0,2.4,0,.71,0,1.25.55,1.24,1.23,0,.68-.54,1.2-1.26,1.21-.39,0-.79,0-1.18,0Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvicon);
export default __webpack_public_path__ + "static/media/cvicon.1483b1e3e5059c88201990b51776e01d.svg";
export { ForwardRef as ReactComponent };